import moment from "moment";
import {
  GET_LIVE_COURSES,
  SET_PAGE,
  SET_SEARCH,
} from "../../shared/constants/ActionTypes";

const initialLiveCourses = {
  liveCourses: [],
  liveCourseCount: 0,
  page: 1,
  search: "",
};

const liveCourseReducer = (state = initialLiveCourses, action) => {
  switch (action.type) {
    case GET_LIVE_COURSES:
      return {
        ...state,
        liveCourses: action.payload.liveCourses.map((liveCourse) => {
          return {
            ...liveCourse,
            courseEndDateFormatted: liveCourse.courseEndDate
              ? moment(liveCourse.courseEndDate).format("ll")
              : null,
            courseStartDateFormatted: liveCourse.courseStartDate
              ? moment(liveCourse.courseStartDate).format("ll")
              : null,
            updatedAtFormatted: moment(liveCourse.createdAt).format("ll"),
            priceFormatted: `${liveCourse.price} € `,
            categoryName: liveCourse.categoryId?.categoryName,
            tutorName: liveCourse.tutorId
              ? liveCourse.tutorId?.firstName +
                " " +
                liveCourse.tutorId?.lastName
              : null,

            // totalCourseDuration: `${liveCourse.totalCourseDuration} min`,
          };
        }),
        liveCourseCount: action.payload.totalCount,
      };

    case SET_PAGE:
      return {
        ...state,
        page: action.payload,
      };

    case SET_SEARCH:
      return {
        ...state,
        search: action.payload,
      };
    default:
      return state;
  }
};

export default liveCourseReducer;
